// extracted by mini-css-extract-plugin
export default {"body":"style_body__Ista6","loading":"style_loading__4UDtR"};